module.exports = __webpack_public_path__ + "static/media/receipt.d9fef878.svg";